import styled from 'styled-components';
import { colors, typography, spacing, shadows, borderRadius, breakpoints } from '../../styles/theme';

export const CardContainer = styled.div`
  background: ${colors.neutral.white};
  border-radius: ${borderRadius['2xl']};
  padding: ${spacing.xl};
  box-shadow: ${shadows.card};
  border: 1px solid ${colors.neutral.gray200};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${spacing.md};
  max-width: 480px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: ${breakpoints.md}) {
    padding: ${spacing.lg};
  }
`;

export const StatusBadge = styled.span`
  background: ${colors.primary.teal};
  color: ${colors.neutral.white};
  font-size: ${typography.fontSize.xs};
  font-weight: ${typography.fontWeight.bold};
  padding: ${spacing.xs} ${spacing.md};
  border-radius: ${borderRadius.full};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const PriceHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xs};
`;

export const PriceText = styled.h3`
  font-size: ${typography.fontSize['3xl']};
  font-weight: ${typography.fontWeight.extrabold};
  color: ${colors.primary.orange};
  margin: 0;
`;

export const PriceSubtext = styled.p`
  font-size: ${typography.fontSize.sm};
  color: ${colors.neutral.gray500};
  margin: 0;
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid ${colors.neutral.gray200};
  margin: ${spacing.xs} 0;
`;

export const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};
  width: 100%;
  text-align: left;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${spacing.sm};
  font-size: ${typography.fontSize.base};
  color: ${colors.neutral.gray700};

  svg {
    color: ${colors.primary.teal};
    flex-shrink: 0;
  }
`;

export const WhatsAppButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.sm};
  width: 100%;
  padding: 1rem ${spacing.lg};
  background: #25d366;
  color: ${colors.neutral.white};
  font-size: ${typography.fontSize.lg};
  font-weight: ${typography.fontWeight.bold};
  border-radius: ${borderRadius.xl};
  text-decoration: none;
  transition: all 0.25s ease;
  box-shadow: ${shadows.md};
  cursor: pointer;

  &:hover {
    background: #1eb957;
    transform: translateY(-2px);
    box-shadow: ${shadows.lg};
  }

  svg {
    font-size: 1.4rem;
  }
`;

export const FooterNote = styled.p`
  font-size: ${typography.fontSize.xs};
  color: ${colors.neutral.gray500};
  margin: 0;
`;
